import { ServiceCall } from "support/network/ServiceCallAction"
import { prepareHeadersFromState } from "../../HeadersUtils"

import { CLONE_IDEA_TEMPLATE_ADD_FAILURE, CLONE_IDEA_TEMPLATE_ADD_STARTED, CLONE_IDEA_TEMPLATE_ADD_SUCCESS, CLONE_SCORECARD_TEMPLATE_ADD_FAILURE, CLONE_SCORECARD_TEMPLATE_ADD_STARTED, CLONE_SCORECARD_TEMPLATE_ADD_SUCCESS, GET_IDEA_TEMPLATE_EDIT_ID_FAILURE, GET_IDEA_TEMPLATE_EDIT_ID_STARTED, GET_IDEA_TEMPLATE_EDIT_ID_SUCCESS, GET_IDEA_TEMPLATE_LIST_FAILURE, GET_IDEA_TEMPLATE_LIST_STARTED, GET_IDEA_TEMPLATE_LIST_SUCCESS, GET_SCORECARD_TEMPLATE_EDIT_ID_FAILURE, GET_SCORECARD_TEMPLATE_EDIT_ID_STARTED, GET_SCORECARD_TEMPLATE_EDIT_ID_SUCCESS, GET_SCORECARD_TEMPLATE_LIST_FAILURE, GET_SCORECARD_TEMPLATE_LIST_STARTED, GET_SCORECARD_TEMPLATE_LIST_SUCCESS, POST_IDEA_TEMPLATE_CREATE_FAILURE, POST_IDEA_TEMPLATE_CREATE_STARTED, POST_IDEA_TEMPLATE_CREATE_SUCCESS, POST_SCORECARD_TEMPLATE_CREATE_FAILURE, POST_SCORECARD_TEMPLATE_CREATE_STARTED, POST_SCORECARD_TEMPLATE_CREATE_SUCCESS, PUT_IDEA_TEMPLATE_EDIT_FAILURE, PUT_IDEA_TEMPLATE_EDIT_STARTED, PUT_IDEA_TEMPLATE_EDIT_SUCCESS, PUT_SCORECARD_TEMPLATE_EDIT_FAILURE, PUT_SCORECARD_TEMPLATE_EDIT_STARTED, PUT_SCORECARD_TEMPLATE_EDIT_SUCCESS } from "actions/sync/templates/Constants"


/**
 * Safely converts an object to a JSON string.
 * @param {any} obj - The object to convert.
 * @returns {string|null} - JSON string if successful, or null if failed.
 */
export function safeJSONStringify(obj) {
  try {
    if (typeof obj === 'string') {
      // Check if it's already a valid JSON string
      JSON.parse(obj); // will throw if invalid
      return obj;
    }

    return JSON.stringify(obj); // pretty print
  } catch (error) {
    console.error('JSON conversion failed:', error);
    return null;
  }
}


// const setBenchUserEndpoint = ({
//   baseUrl,
//   filterDataWithOrderArray,
//   filterDataWithRolesArray ,
//   filterDataWithSkillArray,
//   filterDataWithCommunitiesArray,
// }) => {
//   let url = baseUrl
//     url += `?${encodeURIComponent('order')}=${filterDataWithOrderArray}`
//     url += `&${encodeURIComponent('roles')}=${filterDataWithRolesArray}`
//     url += `&${encodeURIComponent('skills')}=${filterDataWithSkillArray}`
//     url += `&${encodeURIComponent('communities')}=${filterDataWithCommunitiesArray}`
//   return url
// }

function setCreateScorecardTemplateEndpoint({myEmail,templateJson,templateActive,templateName,totalWeight}) {
  const templateScorecardJsonConvert = safeJSONStringify(templateJson)
  return `${encodeURIComponent('loggedUserEmail')}=${encodeURIComponent(myEmail)}&${encodeURIComponent('scoreCardJson')}=${encodeURIComponent(templateScorecardJsonConvert)}&${encodeURIComponent('templateActive')}=${encodeURIComponent(templateActive)}&${encodeURIComponent('templateName')}=${encodeURIComponent(templateName)}&${encodeURIComponent('totalWeight')}=${encodeURIComponent(totalWeight)}`        
}

function setEditScorecardTemplateEndpoint({myEmail,scorecardTemplateJsonValue,id}) {
  const {templateActive,templateName,totalWeight,templateJson} = scorecardTemplateJsonValue || {}
  const templateEditScorecardJsonConvert = safeJSONStringify(templateJson)
  return `${encodeURIComponent('loggedUserEmail')}=${encodeURIComponent(myEmail)}&${encodeURIComponent('scoreCardJson')}=${encodeURIComponent(templateEditScorecardJsonConvert)}&${encodeURIComponent('templateId')}=${encodeURIComponent(id)}&${encodeURIComponent('templateActive')}=${encodeURIComponent(templateActive)}&${encodeURIComponent('templateName')}=${encodeURIComponent(templateName)}&${encodeURIComponent('totalWeight')}=${encodeURIComponent(totalWeight)}`        
  // return `${encodeURIComponent('loggedUserEmail')}=${encodeURIComponent(myEmail)}&${encodeURIComponent('scoreCardJson')}=${encodeURIComponent(scorecardTemplateJsonValue)}&${encodeURIComponent('templateId')}=${encodeURIComponent(id)}`        
}

function setCreateIdeaTemplateEndpoint({myEmail,templateJson,templateActive,templateName,totalWeight}) {
  const templateIdeaJsonConvert = safeJSONStringify(templateJson)
  return `${encodeURIComponent('loggedUserEmail')}=${encodeURIComponent(myEmail)}&${encodeURIComponent('ideaTemplateJson')}=${encodeURIComponent(templateIdeaJsonConvert)}&${encodeURIComponent('templateActive')}=${encodeURIComponent(templateActive)}&${encodeURIComponent('templateName')}=${encodeURIComponent(templateName)}&${encodeURIComponent('totalWeight')}=${encodeURIComponent(totalWeight)}`        
}

function setEditIdeaTemplateEndpoint({myEmail,IdeaTemplateJsonValue,id}) {
  const {templateActive,templateName,totalWeight,templateJson} = IdeaTemplateJsonValue || {}
  const templateEditIdeaJsonConvert = safeJSONStringify(templateJson)
  return `${encodeURIComponent('loggedUserEmail')}=${encodeURIComponent(myEmail)}&${encodeURIComponent('ideaTemplateJson')}=${encodeURIComponent(templateEditIdeaJsonConvert)}&${encodeURIComponent('templateId')}=${encodeURIComponent(id)}&${encodeURIComponent('templateActive')}=${encodeURIComponent(templateActive)}&${encodeURIComponent('templateName')}=${encodeURIComponent(templateName)}&${encodeURIComponent('totalWeight')}=${encodeURIComponent(totalWeight)}`        
}

function setCloneIdeaTemplateEndpoint(IdeaParams) {
  const {templateName,myEmail,id} = IdeaParams || {}
  return `${encodeURIComponent('userEmail')}=${encodeURIComponent(myEmail)}&${encodeURIComponent('templateId')}=${encodeURIComponent(id)}&${encodeURIComponent('templateName')}=${encodeURIComponent(templateName)}`        
}

function setCloneScorecardTemplateEndpoint(scorecardParams) {
  const {templateName,myEmail,id} = scorecardParams || {}
  return `${encodeURIComponent('userEmail')}=${encodeURIComponent(myEmail)}&${encodeURIComponent('templateId')}=${encodeURIComponent(id)}&${encodeURIComponent('templateName')}=${encodeURIComponent(templateName)}`        
}



export const createScorecardTemplateURL = 'api/v1/innovate/template/scorecardtemplate/create'
export const updateScorecardTemplateURL = 'api/v1/innovate/template/scorecardtemplate/update'
export const listScorecardTemplateURL = 'api/v1/innovate/template/scorecardtemplate/list'
export const cloneScorecardTemplateURL = 'api/v1/innovate/template//scorecardtemplate/clone'
export const cloneIdeaTemplateURL = 'api/v1/innovate/template//ideatemplate/clone'

export const createIdeaTemplateURL = 'api/v1/innovate/template/ideatemplate/create'
export const updateIdeaTemplateURL = 'api/v1/innovate/template/ideatemplate/update'
export const listIdeaTemplateURL = 'api/v1/innovate/template/ideatemplate/list'
export const edit_Id_IdeaTemplateURL = 'api/v1/innovate/template/ideatemplate/edit/##templated##'
export const edit_Id_ScorecardTemplateURL = 'api/v1/innovate/template/scorecardtemplate/edit/##templated##'


  export function postIdeaTemplateCreate(myEmail,adminCreateTemplateData,onSuccess,onFailure) {
    const {templateJson,templateActive,templateName,totalWeight} = adminCreateTemplateData 
    const apiCall = new ServiceCall()
    apiCall.startedReqType = POST_IDEA_TEMPLATE_CREATE_STARTED
    apiCall.successReqType = POST_IDEA_TEMPLATE_CREATE_SUCCESS
    apiCall.failureReqType = POST_IDEA_TEMPLATE_CREATE_FAILURE
    apiCall.setEndpointFromState = () => createIdeaTemplateURL
    apiCall.method = 'POST'
    apiCall.setBodyFromState= ()=> setCreateIdeaTemplateEndpoint({myEmail,templateJson,templateActive,templateName,totalWeight})
    apiCall.getHeadersFromState = prepareHeadersFromState
    apiCall.onSuccess = onSuccess
    apiCall.onFailure = onFailure
    // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
    apiCall.auth = true
    return apiCall.getAction()
  }

  export function putIdeaTemplateEdit(myEmail,IdeaTemplateJsonValue,id,onSuccess,onFailure) {
    const apiCall = new ServiceCall()
    apiCall.startedReqType = PUT_IDEA_TEMPLATE_EDIT_STARTED
    apiCall.successReqType = PUT_IDEA_TEMPLATE_EDIT_SUCCESS
    apiCall.failureReqType = PUT_IDEA_TEMPLATE_EDIT_FAILURE
    apiCall.setEndpointFromState = () => updateIdeaTemplateURL
    apiCall.method = 'PUT'
    apiCall.setBodyFromState= ()=> setEditIdeaTemplateEndpoint({myEmail,IdeaTemplateJsonValue,id})
    apiCall.getHeadersFromState = prepareHeadersFromState
    apiCall.onSuccess = onSuccess
    apiCall.onFailure = onFailure
    // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
    apiCall.auth = true
    return apiCall.getAction()
  }


export function getIdeaTemplatelist() {
    const apiCall = new ServiceCall()
    apiCall.startedReqType = GET_IDEA_TEMPLATE_LIST_STARTED
    apiCall.successReqType = GET_IDEA_TEMPLATE_LIST_SUCCESS
    apiCall.failureReqType = GET_IDEA_TEMPLATE_LIST_FAILURE
    apiCall.setEndpointFromState = () =>
      `${listIdeaTemplateURL}`
    apiCall.method = 'GET'
    apiCall.getHeadersFromState = prepareHeadersFromState
    // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
    apiCall.auth = true
    return apiCall.getAction()
}

  export function postScorecardTemplateCreate(myEmail,adminCreateTemplateData,onSuccess,onFailure) {
  
    const {templateJson,templateActive,templateName,totalWeight} = adminCreateTemplateData 
    
    const apiCall = new ServiceCall()
    apiCall.startedReqType = POST_SCORECARD_TEMPLATE_CREATE_STARTED
    apiCall.successReqType = POST_SCORECARD_TEMPLATE_CREATE_SUCCESS
    apiCall.failureReqType = POST_SCORECARD_TEMPLATE_CREATE_FAILURE
    apiCall.setEndpointFromState = () => createScorecardTemplateURL
    apiCall.method = 'POST'
    apiCall.setBodyFromState= ()=> setCreateScorecardTemplateEndpoint({myEmail,templateJson,templateActive,templateName,totalWeight})
    apiCall.getHeadersFromState = prepareHeadersFromState
    apiCall.onSuccess = onSuccess
    apiCall.onFailure = onFailure
    // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
    apiCall.auth = true
    return apiCall.getAction()
  }

  export function putScorecardTemplateEdit(myEmail,scorecardTemplateJsonValue,id,onSuccess,onFailure) {
  
    // const {templateJson,templateId} = adminEditTemplateData 
    
    const apiCall = new ServiceCall()
    apiCall.startedReqType = PUT_SCORECARD_TEMPLATE_EDIT_STARTED
    apiCall.successReqType = PUT_SCORECARD_TEMPLATE_EDIT_SUCCESS
    apiCall.failureReqType = PUT_SCORECARD_TEMPLATE_EDIT_FAILURE
    apiCall.setEndpointFromState = () => updateScorecardTemplateURL
    apiCall.method = 'PUT'
    apiCall.setBodyFromState= ()=> setEditScorecardTemplateEndpoint({myEmail,scorecardTemplateJsonValue,id})
    apiCall.getHeadersFromState = prepareHeadersFromState
    apiCall.onSuccess = onSuccess
    apiCall.onFailure = onFailure
    // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
    apiCall.auth = true
    return apiCall.getAction()
  }


export function getScorecardTemplatelist() {
    const apiCall = new ServiceCall()
    apiCall.startedReqType = GET_SCORECARD_TEMPLATE_LIST_STARTED
    apiCall.successReqType = GET_SCORECARD_TEMPLATE_LIST_SUCCESS
    apiCall.failureReqType = GET_SCORECARD_TEMPLATE_LIST_FAILURE
    apiCall.setEndpointFromState = () =>
      `${listScorecardTemplateURL}`
    apiCall.method = 'GET'
    apiCall.getHeadersFromState = prepareHeadersFromState
    // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
    apiCall.auth = true
    return apiCall.getAction()
}

export function getIdeaTemplateEditID(templatedIdParams) {
    const apiCall = new ServiceCall()
    apiCall.startedReqType = GET_IDEA_TEMPLATE_EDIT_ID_STARTED
    apiCall.successReqType = GET_IDEA_TEMPLATE_EDIT_ID_SUCCESS
    apiCall.failureReqType = GET_IDEA_TEMPLATE_EDIT_ID_FAILURE
    apiCall.setEndpointFromState = () => edit_Id_IdeaTemplateURL.replace('##templated##',templatedIdParams)
    apiCall.method = 'GET'
    apiCall.getHeadersFromState = prepareHeadersFromState
    // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
    apiCall.auth = true
    return apiCall.getAction()
}

export function getScorecardTemplateEditID(templatedIdParams) {
    const apiCall = new ServiceCall()
    apiCall.startedReqType = GET_SCORECARD_TEMPLATE_EDIT_ID_STARTED
    apiCall.successReqType = GET_SCORECARD_TEMPLATE_EDIT_ID_SUCCESS
    apiCall.failureReqType = GET_SCORECARD_TEMPLATE_EDIT_ID_FAILURE
    apiCall.setEndpointFromState = () => edit_Id_ScorecardTemplateURL.replace('##templated##',templatedIdParams)
    apiCall.method = 'GET'
    apiCall.getHeadersFromState = prepareHeadersFromState
    // apiCall.transformResponseDataWithState = transformGetChallengeByIdService
    apiCall.auth = true
    return apiCall.getAction()
}



export function cloneScoreCardTemplate(scorecardParams,onSuccess,onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = CLONE_SCORECARD_TEMPLATE_ADD_STARTED
  apiCall.successReqType = CLONE_SCORECARD_TEMPLATE_ADD_SUCCESS
  apiCall.failureReqType = CLONE_SCORECARD_TEMPLATE_ADD_FAILURE
  apiCall.setEndpointFromState = () => cloneScorecardTemplateURL
  apiCall.method = 'POST'
  apiCall.setBodyFromState= ()=> setCloneScorecardTemplateEndpoint(scorecardParams)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}

export function cloneIdeaTemplate(IdeaParams,onSuccess,onFailure) {
  const apiCall = new ServiceCall()
  apiCall.startedReqType = CLONE_IDEA_TEMPLATE_ADD_STARTED
  apiCall.successReqType = CLONE_IDEA_TEMPLATE_ADD_SUCCESS
  apiCall.failureReqType = CLONE_IDEA_TEMPLATE_ADD_FAILURE
  apiCall.setEndpointFromState = () => cloneIdeaTemplateURL
  apiCall.method = 'POST'
  apiCall.setBodyFromState= ()=> setCloneIdeaTemplateEndpoint(IdeaParams)
  apiCall.getHeadersFromState = prepareHeadersFromState
  apiCall.onSuccess = onSuccess
  apiCall.onFailure = onFailure
  apiCall.auth = true
  return apiCall.getAction()
}
